import { z } from 'zod';
import { zodSelectOption, zodWeapon } from '@/shared/lib/validations';

export const multipleWeaponSelectionSchema = z.object({
  weapon: z.array(zodWeapon),
  orgNpu: zodSelectOption.extend({ isPayable: z.boolean() }),
});
